<template>
    <el-form ref="form" label-width="150px" :model="form" size="small" :rules="rules">
        <div style="margin: 50px 0;"></div>
        <div style="width:1000px;">
            <el-form-item label="Receiver" prop="CheckedPartnersID">
                <el-checkbox-group  v-model="form.CheckedPartnersID" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="item in partnerList"
                                    :key="item[0].ID"
                                    :label="item[0].ID"
                                    :value="item[0].ID">
                                    {{item[0].CompanyName}}
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </div>
        <br>
        <div style="width:1000px;">
            <el-form-item label="Title" prop="Title">
                <el-input v-model="form.Title"></el-input>
            </el-form-item>
        </div>

        <div id="description" style="width:1000px; height:280px; padding-left:10px;">Description</div>         
            <br><br><br>
            <div style="padding-top:100px; float:left;">
                <el-button class="close" type="primary" @click="close">Close</el-button>
            </div> 
            <div style="padding-left:850px; padding-top:100px; float:left;">
                <el-button class="submit" type="primary" @click="submit">Submit</el-button>
            </div>
    </el-form>
</template>

<script>
export default {
    props:{
        id:{}
    },
    data () {
        return {
            checkAll: false,
            isIndeterminate: true,
            PartnersID: [],
            partnerList:[],
            editor:"",
            form:{ 
                CheckedPartnersID: [],
                Title:""
            },
            rules:{
                CheckedPartnersID:[{ required: true, message: 'Please select a receiver !', trigger: 'blur' }],
                Title:[{ required: true, message: 'Please fill in a title !', trigger: 'blur' }]
            }
        };
    },
    mounted () {
        this.$http.get("getAccountBindingAll",{},(data)=>{
            data = data.data;
            this.partnerList = data;
            for(let i in data) {
                this.PartnersID.push(data[i].ID);
            }
        });

        let E = window.wangEditor;
        this.editor = new E('#description');
        this.editor.customConfig.zIndex = 100;
        // 上传图片到服务器，base64形式
        this.editor.customConfig.uploadImgShowBase64 = true;
        // 创建一个富文本编辑器
        this.editor.create();
    },
    methods:{
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                this.form.CheckedPartnersID = this.form.CheckedPartnersID.join(";");
                let url = "sendEmailPartner";
                this.$http.put(url,{
                    CheckedPartnersID:this.form.CheckedPartnersID,
                    Title:this.form.Title,
                    Description:this.editor.txt.html()  
                },(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.$router.push("/partners");
                });
            });
        },
        close () {
            this.$router.push("/partners");
        },
        handleCheckAllChange(val) {
            this.form.CheckedPartnersID = val ? this.PartnersID : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.partnerList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.partnerList.length;
        }
    }
};
</script>

